import { usePartner } from "../helpers/BrandPageAPI";

const Footer = () => {
  const { partnerData } = usePartner();
  const stoneName = partnerData?.StoneName;
  return (
    <>
      <footer className="footer-area">
        <div className="copyright text-center">
          &copy; {new Date().getFullYear()} {stoneName} All Rights Reserved
        </div>
      </footer>
    </>
  );
};

export default Footer;
